export default function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.5"
      height="18.305"
      viewBox="0 0 13.5 18.305"
    >
      <g transform="translate(-5.25 -2.695)">
        <path
          d="M6.75,0,6.211.516.961,5.766,2.039,6.844,6,2.883V15.3H7.5V2.883l3.961,3.961,1.078-1.078L7.289.516ZM0,16.8v1.5H13.5V16.8Z"
          transform="translate(5.25 2.695)"
          fill="#0f21d8"
        />
      </g>
    </svg>
  );
}
